import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ServiceOrderLoader from './_load/ServiceOrderLoader'
import FormReplyLoader from './_load/FormReplyLoader'

const TemplateVCIPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <FormReplyLoader>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent templateId={parseInt(templateId)} />
        </FormReplyLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateVCIPdfPage
